module.exports = __webpack_public_path__ + "cb84232f7865d361cd22b1753a526075.pdf";